import React from 'react';
import {Modal, Table} from 'antd';
import {DeletionError} from "../../../api";

// Interface für die Komponenten-Props
interface DeletionErrorModalProps {
    errorList: DeletionError[];
    modalVisible: boolean;
    onClose: () => void;
    errorMessage: string;
}

const resolveCreationTypeName = (value: string) => {
    switch (value){
        case "PREFAB":
            return "Komponente";
        case "TEST":
            return "Test";
        case "TEST_PLAN":
            return "Testplan";
        default:
            return "Undefiniert";
    }
}

const DeletionErrorModal: React.FC<DeletionErrorModalProps> = ({errorList, modalVisible, onClose, errorMessage}) => {
    // Definiere die Spalten für die Tabelle
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Typ',
            dataIndex: 'creationType',
            key: 'creationType',
            render: (text: string) => {
                return resolveCreationTypeName(text);
            },
        },
        {
            title: 'System',
            dataIndex: ['systemDto', 'name'],
            key: 'systemDto',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
    ];

    return (
        <Modal
            title="Fehlerliste"
            open={modalVisible}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            <span style={{fontSize: '14px', color: 'gray'}}>{errorMessage}</span>
            <Table
                dataSource={errorList}
                columns={columns}
                rowKey="id"
                pagination={false}
                locale={{ emptyText: 'Keine Daten vorhanden' }}
            />
        </Modal>
    );
};

export default DeletionErrorModal;